import map from 'lodash/map';

import calcLicenses from '../common/calcLicense';

type PipelineVersion = {
  id: string;
  versionMajor?: number | string;
  versionMinor?: number | string;
};

type DeploymentLike = {
  replicaName?: string;
  pipeline: { id: string; name?: string; versionMajor?: number | string };
};

export const createObjectPipelineVersion = (pipeline: PipelineVersion) => ({
  value: pipeline.id,
  label: `${pipeline?.versionMajor}.${pipeline?.versionMinor}`
});

export const createObjectOption = (deployment: DeploymentLike) => {
  if (deployment?.replicaName) {
    const removeNameMultiInstanceThePipeline =
      deployment?.pipeline?.name?.replace?.(`-${deployment?.replicaName}`, '');
    return {
      label: `${removeNameMultiInstanceThePipeline} - V${deployment?.pipeline?.versionMajor}`,
      value: deployment?.pipeline.id
    };
  }
  return {
    label: `${deployment?.pipeline?.name} - V${deployment?.pipeline?.versionMajor}`,
    value: deployment?.pipeline.id
  };
};

type SearchPipeline = {
  _id: string;
  name: string;
  versionMajor: number | string;
};

export const normalizePipelines = (pipelines: SearchPipeline[]) =>
  map(pipelines, pipeline => ({
    label: `${pipeline.name} - V${pipeline.versionMajor}`,
    // eslint-disable-next-line no-underscore-dangle
    value: pipeline?._id
  }));

export const normalizeSize = (name?: string) => {
  if (!name) return '';
  return name?.split('-')[0];
};

export const normalizeNamePipeline = (
  name?: string,
  multiInstanceName?: string
) => (multiInstanceName ? `${name}-${multiInstanceName}` : name);

type ViewDeployData = {
  pipeline: { name?: string; [key: string]: unknown };
  parameterizedReplica?: string;
  activeConfiguration?: { name?: string; [key: string]: unknown };
  consumers?: number;
  replicas?: number;
  [key: string]: unknown;
};

export const createObjectViewDeploy = (data: ViewDeployData) => {
  const name = normalizeNamePipeline(
    data?.pipeline.name,
    data?.parameterizedReplica
  );
  return {
    ...data,
    pipeline: {
      ...data?.pipeline,
      name
    },
    activeConfiguration: {
      ...data.activeConfiguration,
      actualConsumers: data.consumers
    },
    licenses: calcLicenses(data?.activeConfiguration?.name, data?.replicas),
    availableReplicas: `${data.replicas}/${data.replicas}`,
    errorCount: 0,
    oomCount: 0,
    status: { text: 'STARTING' }
  };
};
